/**
 * Admin Group (Role) Definitions Logic
 */
export function initGroups() {
    const modalGroupElem = document.getElementById('modalGroup');
    if (!modalGroupElem) return;

    const modalGroup = new bootstrap.Modal(modalGroupElem);
    const formGroup = document.getElementById('formGroup');
    const modalTitle = document.getElementById('modalGroupLabel');
    const btnSubmit = document.getElementById('btnSubmitGroup');

    const btnCreateGroup = document.getElementById('btnCreateGroup');
    if (btnCreateGroup) {
        btnCreateGroup.addEventListener('click', function() {
            formGroup.reset();
            formGroup.action = this.dataset.urlStore;
            modalTitle.innerText = "Create New Group";
            btnSubmit.innerText = "Create Group";
            modalGroup.show();
        });
    }

    $(document).on('click', '.btn-edit-group', function() {
        const id = $(this).data('id');
        const urlJson = $(this).data('url-json');
        const urlUpdate = $(this).data('url-update');
        
        Swal.fire({ title: 'Loading...', didOpen: () => { Swal.showLoading(); } });

        $.get(urlJson, function(data) {
            Swal.close();
            formGroup.action = urlUpdate;
            modalTitle.innerText = `Edit Group: ${data.title}`;
            btnSubmit.innerText = "Update Group";
            
            document.getElementById('name').value = data.name;
            document.getElementById('title').value = data.title;
            document.getElementById('description').value = data.description;

            modalGroup.show();
        });
    });

    $(document).on('click', '.btn-delete-group', function(e) {
        e.preventDefault();
        const form = $(this).closest('form');
        Swal.fire({
            title: 'Delete Group?',
            text: "Removing this might break user associations!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, Delete'
        }).then((result) => {
            if (result.isConfirmed) form.submit();
        });
    });
}
